import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["disablePictureInPicture"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "avatar-container"
}
const _hoisted_5 = {
  key: 0,
  class: "placeholder-for-promoted"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconAccountOffOutline = _resolveComponent("IconAccountOffOutline")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_ScreenShare = _resolveComponent("ScreenShare")
  const _component_VideoBackground = _resolveComponent("VideoBackground")
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_IconAccountCircleOutline = _resolveComponent("IconAccountCircleOutline")
  const _component_VideoBottomBar = _resolveComponent("VideoBottomBar")

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: ($props.placeholderForPromoted ? 'placeholder-' : '') + 'container_' + $options.peerId + '_video_incoming',
    ref: "videoContainer",
    class: _normalizeClass(["video-container", $options.containerClass]),
    onMouseover: _cache[2] || (_cache[2] = $event => ($data.mouseover = true)),
    onMouseleave: _cache[3] || (_cache[3] = $event => ($data.mouseover = false)),
    onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('clickVideo')))
  }, [
    _createVNode(_component_TransitionWrapper, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass([$options.videoWrapperClass, "videoWrapper"]),
          style: _normalizeStyle($options.videoWrapperStyle)
        }, [
          _createElementVNode("video", {
            ref: "video",
            disablePictureInPicture: !$props.isBig,
            class: _normalizeClass([$props.fitVideo ? 'video--fit' : 'video--fill', "video"]),
            onPlaying: _cache[0] || (_cache[0] = (...args) => ($options.updateVideoAspectRatio && $options.updateVideoAspectRatio(...args)))
          }, null, 42, _hoisted_2),
          ($props.isPresenterOverlay && $data.mouseover)
            ? (_openBlock(), _createBlock(_component_IconAccountOffOutline, {
                key: 0,
                class: "presenter-icon__hide",
                "aria-label": $options.t('spreed', 'Hide presenter video'),
                title: $options.t('spreed', 'Hide presenter video'),
                size: 32,
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('clickPresenter')))
              }, null, 8, ["aria-label", "title"]))
            : _createCommentVNode("", true),
          ($options.isLoading)
            ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                key: 1,
                size: $options.avatarSize / 2,
                class: "video-loading"
              }, null, 8, ["size"]))
            : _createCommentVNode("", true),
          ($options.screenshotModeUrl && $props.isPresenterOverlay)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "dev-mode-video--presenter",
                alt: "dev-mode-video--presenter",
                src: $options.screenshotModeUrl
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ], 6), [
          [_vShow, $options.showVideo]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_TransitionWrapper, { name: "fade" }, {
      default: _withCtx(() => [
        ($options.showSharedScreen)
          ? (_openBlock(), _createBlock(_component_ScreenShare, {
              key: 0,
              "is-big": $props.isBig,
              token: $props.token,
              "call-participant-model": $props.model,
              "shared-data": $props.sharedData
            }, null, 8, ["is-big", "token", "call-participant-model", "shared-data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_TransitionWrapper, { name: "fade" }, {
      default: _withCtx(() => [
        ($options.showBackgroundAndAvatar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_VideoBackground, {
                "display-name": $options.displayName,
                user: $options.participantUserId
              }, null, 8, ["display-name", "user"]),
              _createVNode(_component_AvatarWrapper, {
                id: $options.participantUserId,
                token: $props.token,
                name: $options.displayName,
                source: $options.participantActorType,
                size: $options.avatarSize,
                loading: $options.isLoading,
                "disable-menu": "",
                "disable-tooltip": ""
              }, null, 8, ["id", "token", "name", "source", "size", "loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_TransitionWrapper, { name: "fade" }, {
      default: _withCtx(() => [
        ($options.showPlaceholderForPromoted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ($props.isPromoted || $props.isSelected)
                ? (_openBlock(), _createBlock(_component_IconAccountCircleOutline, {
                    key: 0,
                    "fill-color": "#FFFFFF",
                    size: 64
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    ($options.connectionMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([$options.connectionMessageClass, "connection-message"])
        }, _toDisplayString($options.connectionMessage), 3))
      : _createCommentVNode("", true),
    (!$props.hideBottomBar)
      ? _renderSlot(_ctx.$slots, "bottom-bar", { key: 1 }, () => [
          _createVNode(_component_VideoBottomBar, _mergeProps({
            "has-shadow": $options.hasVideo,
            "participant-name": $options.participantName
          }, _ctx.$props, { onBottomBarHover: $options.handleHoverEvent }), null, 16, ["has-shadow", "participant-name", "onBottomBarHover"])
        ], true)
      : _createCommentVNode("", true)
  ], 42, _hoisted_1)), [
    [_vShow, !$props.placeholderForPromoted || $props.sharedData.promoted]
  ])
}